import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import { CaretSolidIcon, ThrobberDarkIcon } from '@parchment/icons';
import styled from 'styled-components';
import { alto, emperor, mineShaft } from '../Colors/Colors';
import CircleButton from '../CircleButton/CircleButton';
import { CONTEXTS, SPINNER_SIZE } from './constants';
import { SCALE } from '../Button/DownloadButton';

const noop = () => undefined;

export default function SimplePaginator(_ref) {
  let {
    context = CONTEXTS.DEFAULT,
    currentPage = 1,
    dotIndicatorLimit = 10,
    ghost = false,
    loading,
    loadingMessage = 'Loading message',
    name = 'Name',
    noBorder = true,
    onChange = noop,
    pageCount = 5,
    size = SCALE.medium,
    ...props
  } = _ref;
  const CONTEXTS_ARR = ['dark', 'default', 'configure', 'primary'];
  const [_currentPage, setCurrentPage] = useState(currentPage);

  function handlePrevButtonClick() {
    const prevPage = _currentPage;

    if (prevPage <= 1) {
      setCurrentPage(pageCount);
      onChange(pageCount, prevPage, pageCount);
      return;
    }

    const nextPage = prevPage - 1;
    setCurrentPage(nextPage);
    onChange(nextPage, prevPage, pageCount);
  }

  function handleNextButtonClick() {
    const prevPage = _currentPage;

    if (prevPage >= pageCount) {
      setCurrentPage(1);
      onChange(1, prevPage, pageCount);
      return;
    }

    const nextPage = prevPage + 1;
    setCurrentPage(nextPage);
    onChange(nextPage, prevPage, pageCount);
  }

  function getPagesElement() {
    if (pageCount > dotIndicatorLimit) {
      return /*#__PURE__*/React.createElement(CountIndicator, {
        className: "countIndicator"
      }, "".concat(_currentPage, " / ").concat(pageCount));
    } else {
      const pageCircles = [];

      for (let i = 0; i < pageCount; i++) {
        const active = i === _currentPage - 1;
        const className = 'dot' + (active ? '-current' : '');
        pageCircles.push( /*#__PURE__*/React.createElement(Dot, {
          key: i,
          active: active,
          className: "dot-".concat(i + 1, " ").concat(className)
        }));
      }

      return pageCircles;
    }
  }

  const buttonProps = {
    context: context,
    ghost: ghost,
    noBorder: noBorder,
    size
  };

  const paginatorProps = context => {
    context = CONTEXTS_ARR.indexOf(context) >= 0 ? context : 'default';
    return { ...props,
      loading,
      context,
      name
    };
  };

  if (loading) {
    return /*#__PURE__*/React.createElement(Loading, null, /*#__PURE__*/React.createElement(ThrobberDarkIcon, {
      size: SPINNER_SIZE[size],
      spin: true
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(size, " loadingMessage")
    }, loadingMessage));
  }

  return /*#__PURE__*/React.createElement(Paginator, paginatorProps, /*#__PURE__*/React.createElement(CircleButton, _extends({}, buttonProps, {
    name: "prevButton",
    onClick: () => handlePrevButtonClick()
  }), /*#__PURE__*/React.createElement(CaretSolidIcon, {
    rotate: "90deg"
  })), getPagesElement(), /*#__PURE__*/React.createElement(CircleButton, _extends({}, buttonProps, {
    name: "nextButton",
    onClick: () => handleNextButtonClick()
  }), /*#__PURE__*/React.createElement(CaretSolidIcon, {
    rotate: "-90deg"
  })));
}
const Paginator = /*#__PURE__*/styled.div.withConfig({
  displayName: "SimplePaginator__Paginator",
  componentId: "sc-8quhl4-0"
})(["display:flex;align-items:center;align-content:center;.large{height:50px;width:50px;font-size:25px;}button[name='nextButton']{margin-left:10px;}button[name='prevButton']{margin-right:10px;}"]);
const Dot = /*#__PURE__*/styled.span.withConfig({
  displayName: "SimplePaginator__Dot",
  componentId: "sc-8quhl4-1"
})(["height:8px;width:8px;background-color:", ";border-radius:50%;display:inline-block;margin-left:2px;margin-right:2px;margin-bottom:0;"], props => props.active ? emperor : alto);
const CountIndicator = /*#__PURE__*/styled.span.withConfig({
  displayName: "SimplePaginator__CountIndicator",
  componentId: "sc-8quhl4-2"
})(["background-color:", ";color:white;text-align:center;text-decoration:none;display:inline-block;margin-left:2px;margin-right:2px;padding:0 10px;border-radius:20px;font-weight:bold;font-size:10px;"], mineShaft);
const Loading = /*#__PURE__*/styled.div.withConfig({
  displayName: "SimplePaginator__Loading",
  componentId: "sc-8quhl4-3"
})(["display:flex;align-items:center;align-content:center;div{padding-left:10px;}div.small{font-size:14px;}div.medium{font-size:20px;margin-top:4px;}div.large{font-size:25px;margin-top:4px;}"]);